import { MediaSize } from '@/media/constants/sizeCodes';

import styles from './MediaPreview.module.css';

export const MEDIA_PREVIEW_SIZE_CLASS_MAP: Partial<Record<MediaSize, string>> = {
  [MediaSize.XXSSmall]: styles.mediaPreviewXxs,
  [MediaSize.XSmall]: styles.mediaPreviewXs,
  [MediaSize.Small]: styles.mediaPreviewS,
  [MediaSize.Medium]: styles.mediaPreviewM,
  [MediaSize.Large]: styles.mediaPreviewL,
};
